export default function (state = [], action={}) {
    switch (action.type) {
        case "SET_EGRESS_PROVIDER_PAGEINFO":
        return {
            ...state,
            pageSize:action.payload.pageSize,
            pageNo : action.payload.pageNo
        }; 
        case "GET_EGRESS_PROVIDER_REQUESTED":
            return {
                ...state,
                egress_providers: null,
                egressProviderLoading: true,
                egressProviderError: null
            };
        case "GET_EGRESS_PROVIDER_SUCCESS":
            return {
                ...state,
                egress_providers: action.response && action.response.egress_providers || null,
                egressProviderLoading: false,
                egressProviderError: action.error || action.response.error_message,
            };
        case "GET_EGRESS_PROVIDER_FAILED":
            return {
                ...state,
                egress_providers: null,
                egressProviderLoading: false,
                egressProviderError: action.error
            };
        case "CREATE_EGRESS_PROVIDER_REQUESTED":
            return {
                ...state,
                egress_providers: null,
                egressProviderLoading: true,
                egressProviderError: null
            };
        case "CREATE_EGRESS_PROVIDER_SUCCESS":
            return {
                ...state,
                egress_providers: action.response && action.response.egress_providers || null,
                egressProviderLoading: false,
                egressProviderError: action.error || action.response.error_message,
            };
        case "CREATE_EGRESS_PROVIDER_FAILED":
            return {
                ...state,
                egress_providers: null,
                egressProviderLoading: false,
                egressProviderError: action.error
            };

        case "UPDATE_EGRESS_PROVIDER_REQUESTED":
            return {
                ...state,
                egress_providers: null,
                egressProviderLoading: true,
                egressProviderError: null
            };
        case "UPDATE_EGRESS_PROVIDER_SUCCESS":
            return {
                ...state,
                egress_providers: action.response && action.response.egress_providers || null,
                egressProviderLoading: false,
                egressProviderError: action.error || action.response.error_message,
            };
        case "UPDATE_EGRESS_PROVIDER_FAILED":
            return {
                ...state,
                egress_providers: null,
                egressProviderLoading: false,
                egressProviderError: action.error
            };
        case "DELETE_EGRESS_PROVIDER_REQUESTED":
            return {
                ...state,
                egressProvider: null,
                egressProviderLoading: true,
                egressProviderError: null
            };
        case "DELETE_EGRESS_PROVIDER_SUCCESS":
            return {
                ...state,
                egressProvider: action.response && action.response.egress_provider || null,
                egressProviderLoading: false,
                egressProviderError: action.error || action.response.error_message || null,
                egressProviderErrorMessage: action.error || action.response.error_message || null,
            };
        case "DELETE_EGRESS_PROVIDER_FAILED":
            return {
                ...state,
                egressProvider: null,
                egressProviderLoading: false,
                egressProviderError: action.error
            };

         case "GET_EGRESS_GATEWAY_REQUESTED":
            return {
                ...state,
                egress_gateways: null,
                egressGatewayLoading: true,
                egressGatewayError: null
            };
        case "GET_EGRESS_GATEWAY_SUCCESS":
            return {
                ...state,
                egress_gateways: action.response && action.response.egress_gateways || null,
                egressGatewayLoading: false,
                egressGatewayError: action.error || action.response.error_message,
            };
        case "GET_EGRESS_GATEWAY_FAILED":
            return {
                ...state,
                egress_gateways: null,
                egressGatewayLoading: false,
                egressGatewayError: action.error
            };
        case "CREATE_EGRESS_GATEWAY_REQUESTED":
            return {
                ...state,
                egress_gateways: null,
                egressGatewayLoading: true,
                egressGatewayError: null
            };
        case "CREATE_EGRESS_GATEWAY_SUCCESS":
            return {
                ...state,
                egress_gateways: action.response && action.response.egress_gateways || null,
                egressGatewayLoading: false,
                egressGatewayError: action.error || action.response.error_message,
            };
        case "CREATE_EGRESS_GATEWAY_FAILED":
            return {
                ...state,
                egress_gateways: null,
                egressGatewayLoading: false,
                egressGatewayError: action.error
            };

        case "UPDATE_EGRESS_GATEWAY_REQUESTED":
            return {
                ...state,
                egress_gateways: null,
                egressGatewayLoading: true,
                egressGatewayError: null
            };
        case "UPDATE_EGRESS_GATEWAY_SUCCESS":
            return {
                ...state,
                egress_gateways: action.response && action.response.egress_gateways || null,
                egressGatewayLoading: false,
                egressGatewayError: action.error || action.response.error_message,
            };
        case "UPDATE_EGRESS_GATEWAY_FAILED":
            return {
                ...state,
                egress_gateways: null,
                egressGatewayLoading: false,
                egressGatewayError: action.error
            };
        case "DELETE_EGRESS_GATEWAY_REQUESTED":
            return {
                ...state,
                egressGateway: null,
                egressGatewayLoading: true,
                egressGatewayError: null
            };
        case "DELETE_EGRESS_GATEWAY_SUCCESS":
            return {
                ...state,
                egressGateway: action.response && action.response.egress_gateway || null,
                egressGatewayLoading: false,
                egressGatewayError: action.error || action.response.error_message || null,
                egressGatewayErrorMessage: action.error || action.response.error_message || null,
            };
        case "DELETE_EGRESS_GATEWAY_FAILED":
            return {
                ...state,
                egressGateway: null,
                egressGatewayLoading: false,
                egressGatewayError: action.error
            };
        case "GET_EGRESS_CREDENTIAL_REQUESTED":
            return {
                ...state,
                egressCredentials: null,
                egressCredentialLoading: true,
                egressCredentialError: null
            };
        case "GET_EGRESS_CREDENTIAL_SUCCESS":
            return {
                ...state,
                egressCredentials: action.response && action.response.egress_credentials || null,
                egressCredentialLoading: false,
                egressCredentialError: action.error || action.response.error_message,
            };
        case "GET_EGRESS_CREDENTIAL_FAILED":
            return {
                ...state,
                egressCredentials: null,
                egressCredentialLoading: false,
                egressCredentialError: action.error
            };
        case "CREATE_EGRESS_CREDENTIAL_REQUESTED":
            return {
                ...state,
                egressCredentials: null,
                egressCredentialLoading: true,
                egressCredentialError: null
            };
        case "CREATE_EGRESS_CREDENTIAL_SUCCESS":
            return {
                ...state,
                egressCredentials: action.response && action.response.egress_credentials || null,
                egressCredentialLoading: false,
                egressCredentialError: action.error || action.response.error_message,
            };
        case "CREATE_EGRESS_CREDENTIAL_FAILED":
            return {
                ...state,
                egressCredentials: null,
                egressCredentialLoading: false,
                egressCredentialError: action.error
            };
        
        case "UPDATE_EGRESS_CREDENTIAL_REQUESTED":
            return {
                ...state,
                egressCredentials: null,
                egressCredentialLoading: true,
                egressCredentialError: null
            };
        case "UPDATE_EGRESS_CREDENTIAL_SUCCESS":
            return {
                ...state,
                egressCredentials: action.response && action.response.egress_credentials || null,
                egressCredentialLoading: false,
                egressCredentialError: action.error || action.response.error_message,
            };
        case "UPDATE_EGRESS_CREDENTIAL_FAILED":
            return {
                ...state,
                egressCredentials: null,
                egressCredentialLoading: false,
                egressCredentialError: action.error
            };
        case "DELETE_EGRESS_CREDENTIAL_REQUESTED":
            return {
                ...state,
                egressCredential: null,
                egressCredentialLoading: true,
                egressCredentialError: null
            };
        case "DELETE_EGRESS_CREDENTIAL_SUCCESS":
            return {
                ...state,
                egressCredential: action.response && action.response.egress_credential || null,
                egressCredentialLoading: false,
                egressCredentialError: action.error || action.response.error_message || null,
                egressCredentialErrorMessage: action.error || action.response.error_message || null,
            };
        case "DELETE_EGRESS_CREDENTIAL_FAILED":
            return {
                ...state,
                egressCredential: null,
                egressCredentialLoading: false,
                egressCredentialError: action.error
            };
            
        case "SET_CURRENT_EGRESS_PROVIDER":
            return {
                ...state,
                currentProvider: action.response
            };

        case "GET_EGRESS_MAPPINGS_REQUESTED":
            return {
                ...state,
                egressMappings: null,
                egressMappingsLoading: false,
                egressMappingsError: action.error
            };

        case "GET_EGRESS_MAPPINGS_SUCCESS":
            return {
                ...state,
                egressMappings: action.response && action.response.egress_provider_mappings || null,
                egressMappingsLoading: false,
                egressMappingsError: action.error
            };
                
        case "CREATE_EGRESS_MAPPING_REQUESTED":
            return {
                ...state,
                egressCredential: null,
                egressMappings: null,
                egressMappingsLoading: false,
                egressMappingsError: action.error
            };

        case "CREATE_EGRESS_MAPPING_SUCCESS":
            return {
                ...state,
                egressCredential: action.response && action.response.egress_credential || null,
                egressMappingsLoading: false,
                egressMappingsError: action.error
            };
        default:
            return state;
    }
}
